module.exports = __webpack_public_path__ + "img/payment-empty.54dda2dd.png";